<template>
    <v-dialog v-model="unload_dialog_badge" fullscreen persistent>
        <v-card>
            <v-toolbar class="secondary" dark>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Badges
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-data-table :headers="headers" :items="badges" :search="search">
                    <template v-slot:top>
                        <v-row>
                            <v-col cols="4">
                                <v-text-field label="Search" v-model="search"></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-btn color="secondary" class="mt-3" @click="savedBadge">Save <v-icon
                                        class="ml-2">mdi-content-save</v-icon></v-btn>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:item.Color="{ item }">
                        <v-icon :color="item.Color">
                            mdi-circle
                        </v-icon>
                    </template>
                    <template v-slot:item.BadgeNumber="{ item }">
                        <v-text-field dense v-model="item.BadgeNumber" readonly hide-details></v-text-field>
                    </template>
                    <template v-slot:item.Registered="{ item }">
                        <v-checkbox dense v-model="item.Registered"
                            :color="item.Registered == true ? 'success' : 'primary'" readonly hide-details></v-checkbox>
                    </template>
                    <template v-slot:item.Register="{ item }">
                        <v-checkbox dense v-model="item.Register" :readonly="item.Registered" hide-details></v-checkbox>
                    </template>
                </v-data-table>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
export default {
    props: ['driver', 'unload_dialog_badge'],
    data: function () {
        return {
            search: null,
            headers: [
                { text: 'Registered', value: 'Registered' },
                { text: 'Color', value: 'Color' },
                { text: 'Terminal', value: 'Terminal' },
                { text: 'Badge Number', value: 'BadgeNumber' },
                { text: 'Last Order Date', value: 'LastOrderDate' },
                { text: 'Last Order', value: 'LastOrderID' },
                { text: 'DiffDays', value: 'DiffDays' },
                { text: 'Register', value: 'Register' },
            ],
            badges: [],
        }
    },
    mounted() {
        this.loadTerminalBadges();
    },
    methods: {
        loadTerminalBadges: function () {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('driver-badge/unload/' + this.driver, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.badges = response.data;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        savedBadge: async function () {
            var str = this.$store;
            str.state.isLoading = true;
            const data = await this.badges.filter(x => {
                return x.Register == 1;
            }).map(x => {
                return {
                    BadgeNumber: x.BadgeNumber,
                    DriverID: this.driver,
                    TerminalID: x.TerminalID,
                    CreationDate: moment().format('YYYY-MM-DD'),
                    ExpirationDate: x.ExpirationDate,
                    LastActiveDate: x.LastOrderDate,
                    LastOrderID: x.LastOrderID,
                    isActive: true,
                    LockedOut: false,
                    InactiveBadgeExpirationCountdown: 180 - x.DiffDays,
                    IsPermittedToLoad: 0,
                    IsPermittedToUnload: 0,
                    BadgeType: 2,
                }
            });
            axios
                .post('driver-badge/multi/badge', { Data: data }, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.$emit('closeRecall');
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });

            console.log(data);
        },
    }
}
</script>